import type { IAdProvider, AdStatus, AdProviderConfig } from '../types';

declare global {
  interface Window {
    'showAd': () => Promise<any>;
  }
}

export class MonetagProvider implements IAdProvider {
  readonly providerId = 'monetag' as const;
  private status: AdStatus = 'idle';
  private statusCallbacks: Array<(status: AdStatus) => void> = [];
  private config: AdProviderConfig;

  constructor(config: AdProviderConfig) {
    this.config = config;
  }

  getStatus(): AdStatus {
    return this.status;
  }

  onStatusChange(callback: (status: AdStatus) => void): void {
    this.statusCallbacks.push(callback);
  }

  private setStatus(status: AdStatus) {
    this.status = status;
    this.statusCallbacks.forEach(cb => cb(status));
  }

  async init(): Promise<void> {
    if (typeof window === 'undefined') return;

    if (typeof window.showAd === 'function') {
      this.setStatus('ready');
      return;
    }

    this.setStatus('loading');
    // TODO: 根據 Monetag 文檔添加正確的 SDK 加載邏輯
    const script = document.createElement('script');
    // script.src = `https://monetag.com/sdk.js`; // 需要確認實際的 SDK URL
    script.src = `//munqu.com/sdk.js`; // 示例 URL
    script.setAttribute('data-zone', this.config.projectId as string);
    script.setAttribute('data-sdk', 'showAd');
    document.head.appendChild(script);

    return new Promise((resolve, reject) => {
      script.onload = () => {
        console.log('[Monetag] SDK loaded');
        this.setStatus('ready');
        resolve();
      };
      script.onerror = () => {
        console.error('[Monetag] Failed to load SDK');
        this.setStatus('error');
        reject(new Error('Failed to load Monetag SDK'));
      };
    });
  }

  async open(): Promise<any> {
    if (!window.showAd) {
      throw new Error('Monetag SDK is not available');
    }

    try {
      const data = await window.showAd();
      return data;
    } catch (error) {
      console.error('[Monetag] Ad failed', error);
      throw error;
    }
  }
}
